/**
 * Parse CSV string into rows and columns
 * Handles quoted values, escaped quotes, and newlines inside quoted values
 */
export const parseCSV = (content: string): string[][] => {
  const rows: string[][] = [];
  let values: string[] = [];
  let current = "";
  let inQuotes = false;

  const endValue = () => {
    values.push(current.trim());
    current = "";
  };

  const endRow = () => {
    endValue();
    // Blank lines carry no data; a row of one empty cell is what an empty line parses to.
    if (values.some((value) => value !== "")) {
      rows.push(values);
    }
    values = [];
  };

  for (let i = 0; i < content.length; i++) {
    const char = content[i];
    const nextChar = content[i + 1];

    if (char === '"' && inQuotes && nextChar === '"') {
      current += '"';
      i++;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      endValue();
    } else if (char === "\r" && !inQuotes) {
      // Swallow CR so CRLF files don't leave a stray \r on the last value of each row.
      continue;
    } else if (char === "\n" && !inQuotes) {
      endRow();
    } else {
      current += char;
    }
  }

  if (current !== "" || values.length > 0) {
    endRow();
  }

  return rows;
};
